import React from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { reportsTypeOptions } from 'src/constants/reportsType'
import { useForm } from 'react-hook-form'
import { animalAgeFiltersOptions, animalGenderOptions } from 'src/constants/fieldAnimal'
import { Button, Input, Loading, SelectInput } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { MultiSelectInput } from 'src/components/MultiSelectInput'
import { Grid } from '@material-ui/core'
import { fileDownload } from 'src/assets/png'
import { useStyles } from './styles'
import { useReports } from './hooks/useReports'
import { VALIDATIONS } from 'src/@types/validations'

export const Reports: React.FC = () => {
  const style = useStyles()

  const {
    watch,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors }
  } = useForm<any>({
    resolver: yupResolver(VALIDATIONS.Report),
    defaultValues: {
      tipo: 'ESTOQUE'
    }
  })

  const { onSubmit, isLoading, isProcessingReport, farmList, lotsList } = useReports({ handleSubmit, setValue, watch })

  return (
    <>
      <PageTitle title='Relatórios' />
      {isLoading ? (
        <Loading />
      ) : (
        <form onSubmit={async (formData) => await onSubmit(formData)}>
          <div className={style.recordsForm}>
            <Grid container spacing={2} className={style.recordsFormContent}>
              <Grid item xs={12} md={6}>
                <SelectInput
                  label='Tipo'
                  selectBy='value'
                  showBy={['id']}
                  options={reportsTypeOptions}
                  disabled={isLoading || isProcessingReport}
                  placeholder='Selecionar Tipo'
                  value={watch('tipo') || ''}
                  error={errors?.tipo?.message}
                  onChange={(item: any) => {
                    setValue('tipo', item.value)
                    clearErrors('tipo')
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <SelectInput
                  label='Propriedade'
                  selectBy='idFazenda'
                  showBy={['descricao']}
                  disabled={isLoading || isProcessingReport}
                  options={farmList!}
                  value={watch('idFazenda') || ''}
                  error={errors?.idFazenda?.message}
                  placeholder='Selecionar Propriedade'
                  onChange={(item: any) => {
                    setValue('idFazenda', item.idFazenda)
                    clearErrors('idFazenda')
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Input
                  type='date'
                  max='2999-12-31'
                  disabled={isLoading || isProcessingReport}
                  label='Data Inicial'
                  value={watch('dataInicial') || ''}
                  error={errors?.dataInicial?.message}
                  onChange={(item: any) => {
                    setValue('dataInicial', item)
                    clearErrors('dataInicial')
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Input
                  type='date'
                  max='2999-12-31'
                  disabled={isLoading || isProcessingReport}
                  label='Data Final'
                  value={watch('dataFinal') || ''}
                  error={errors?.dataFinal?.message}
                  onChange={(item: any) => {
                    setValue('dataFinal', item)
                    clearErrors('dataFinal')
                  }}
                />
              </Grid>
            </Grid>
            {(watch('tipo') === 'ESTOQUE_ATUAL' || watch('tipo') === 'PESAGENS') && (
              <div className={style.recordsFormContent}>
                <MultiSelectInput
                  label='Lote'
                  selectBy='id'
                  disabled={isLoading || isProcessingReport}
                  showBy={['descricao']}
                  options={lotsList!}
                  placeholder='Selecionar Lote'
                  value={watch('filtroLotes') || ''}
                  error={errors?.filtroLotes?.message}
                  onChange={(item: any) => {
                    setValue('filtroLotes', item)
                    clearErrors('filtroLotes')
                  }}
                />
                <MultiSelectInput
                  label='Sexo do Animal'
                  selectBy='id'
                  showBy={['value']}
                  disabled={isLoading || isProcessingReport}
                  options={animalGenderOptions}
                  placeholder='Selecionar sexo do animal'
                  value={watch('filtroSexo') || ''}
                  error={errors?.filtroSexo?.message}
                  onChange={(item: any) => {
                    setValue('filtroSexo', item)
                    clearErrors('filtroSexo')
                  }}
                />

                <MultiSelectInput
                  label='Idade'
                  selectBy='id'
                  showBy={['value']}
                  disabled={isLoading || isProcessingReport}
                  options={animalAgeFiltersOptions}
                  value={watch('filtroIdades') || ''}
                  error={errors?.filtroIdades?.message}
                  placeholder='Selecionar idade'
                  onChange={(item: any) => {
                    setValue('filtroIdades', item)
                    clearErrors('filtroIdades')
                  }}
                />
              </div>
            )}
            <div className={style.recordsButtonContainer}>
              <Button type='submit' disabled={isLoading || isProcessingReport} isLoading={isProcessingReport}>
                <img src={fileDownload} alt='Incluir' />
                Exportar
              </Button>
            </div>
          </div>
        </form>
      )}
    </>
  )
}
